<script>
import Loading from 'vue-loading-overlay';

export default {
	components: {
		Loading
	},
	methods: {
		showModal: function (data) {
			this.nakaziloId = data.id;
			this.stKupoprodajnePogodbe = data.st_kupoprodajne_pogodbe;
			this.$refs.modal.show();
		},
		click_okModal: function (evt) {
			evt.preventDefault();
			this.$emit('success', this.nakaziloId, this.stKupoprodajnePogodbe);
			this.$refs.modal.hide();
		},
		click_cancelModal: function (evt) {
			evt.preventDefault();
			this.$refs.modal.hide();
			setTimeout(() => {
				this.clearModal();
			}, 300);
		},
		clearModal: function () {
			this.message.type = null;
			this.message.text = null;
			this.isLoading = false;
			this.nakaziloId = null;
			this.stKupoprodajnePogodbe = null;
		},
		showError: function (message) {
			if (message) {
				this.message.type = this.ACTION_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		}
	},
	data: function () {
		return {
			isLoading: false,
			message: {
				type: null,
				text: null
			},
			ACTION_TYPE_ERROR: 'ERROR',
			nakaziloId: null,
			stKupoprodajnePogodbe: null
		}
	},
	computed: {
	},
	created () {
	}
}
</script>
<template>
	<b-modal ref="modal" @hidden="clearModal" title="Št. kupoprodajne podobe" class="modal-primary" size="sm">
		<loading :active.sync="isLoading"></loading>
		<b-row>
			<b-col>
				<b-form-group label="Št. kupoprodajne pogodbe:">
					<b-form-input type="text" v-model="stKupoprodajnePogodbe"></b-form-input>
				</b-form-group>
			</b-col>
		</b-row>
		<b-alert :variant="message.type && message.type === ACTION_TYPE_ERROR ? 'danger' : 'primary'" :show="message.text && message.text !== ''">{{ message.text }}</b-alert>
		<template slot="modal-footer">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button variant="secondary" @click.stop="click_cancelModal($event)">Prekliči</b-button>
						<b-button variant="primary" @click.stop="click_okModal($event)">Nastavi</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
	</b-modal>
</template>
<style scoped>
.ma_pos {
	text-align: end;
}
</style>


// WEBPACK FOOTER //
// src/components/Modals/DodajanjeStKupoprodajnePogodbeModal.vue